<div *ngIf="shouldShowChatIcon" class="chatbot-icon" [ngClass]="{ 'margin-bottom-class': isButtonPresent }">
  <img [src]="chatBotImageSrc" alt="Chatbot Icon" (click)="toggleChatbot()" />
  <div class="chat-msg-box">
    <div class="chat-msg-box-container">
      <div class="chat-msg-cancel" *ngIf="isChatMsgVisible" (click)="hideChatMessage()">x</div>
      <div class="chat-msg-body" *ngIf="isChatMsgVisible">Hi, I am Mofeed, I have a message for you</div>
      <div class="chat-msg-arrow" *ngIf="isChatMsgVisible"></div>
    </div>
  </div>
  <div class="chat-dot">{{ unreadMessagesCount }}</div>
</div>

<div #chatbotContainer class="chatbot-container" *ngIf="isChatboxOpen"
  [ngClass]="{ 'full-height': isChatboxOpen, 'full-width': isFullWidth }"
  [ngStyle]="{ 'bottom.%': position.bottom, 'right.%': position.right }">
  <div class="resizer" (mousedown)="startResize($event)"></div>
  <div class="verticle-resizer"></div>
  <div class="chatbot-content" [ngClass]="{ 'full-width': isFullWidth }">
    <div class="chatbot-header-icons commonBackgroundColor">
      <img src="assets/images/O3_Sigma_White.png" alt="O3ai"
        style="height: 50px;width: 100px;margin-top: -12px;margin-left : 10px;" /><!--margin-left: 15px;align-items: center;-->
      <div style="margin-left:auto;margin-right: auto;">
        <h2 style="color: #fff;margin-bottom: 5px;">Welcome {{currentUserName}} !</h2>
      </div>
      <mat-icon (click)="toggleFullWidth()" class="cursor-pointer" matTooltip="Full Screen">{{
        isFullWidth ? "fullscreen_exit" : "fullscreen"
        }}</mat-icon>
      <mat-icon (click)="closeChatbot()" matTooltip="Close" class="cursor-pointer">close</mat-icon>
    </div>

    <div class="avatar-div" *ngIf="activeTab === 'messages'">
      <img src="{{ humanAvatarSrc }}" alt="Bot Avatar" class="bot-avatar" />
      <div class="lips" [class.talking]="isSpeaking" [class.not-talking]="!isSpeaking">
      </div>
    </div>

    <div *ngIf="activeTab === 'messages' && isNextBestAction" class="messages">
      <div class="message-inner-wrapper">
        <div class="loader-container" *ngIf="isLoadingMessages">
          <div class="loader"></div>
        </div>
        <cdk-virtual-scroll-viewport itemSize="20" class="message-viewport">
          <div *cdkVirtualFor="let message of messages; let i = index" class="message"
            [dir]="selectedAccent === 'en-US-JasonNeural' ? 'ltr' : 'rtl'">
            <div class="message-content next-action-msg-chips" [class.highlight]="i === currentMessageIndex">
              <div class="message-content-icon">
                <div *ngIf="message.type.includes('Reminder')" class="reminder-circle">
                  R
                </div>
                <a (click)="onClickMessage(message)" class="message-text"
                  [ngClass]="{ 'full-width-font': isFullWidth }">
                  {{ message.content }}
                </a>
              </div>
              <span class="message-time">{{ message.time }}</span>
              <mat-icon *ngIf="message.isRead" class="time-icon" style="font-size: 18px">
                check
              </mat-icon>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>

      </div>
      <div class="chatbot-input  speak-icon">
        <div class="speech-control-container" (mouseenter)="showControls = true" (mouseleave)="showControls = false">
          <!-- Hover buttons -->
          <div class="speech-control-buttons" *ngIf="showControls">
            <button (click)="togglePlayPause()" [ngClass]="isPaused ? 'play' : 'pause'">
              <mat-icon>{{ isPaused ? 'play_arrow' : 'pause' }}</mat-icon>
            </button>
            <button (click)="toggleMute()">
              <mat-icon style="color: #000;">{{ isMuted ? 'volume_off' : 'volume_up' }}</mat-icon>
            </button>
          </div>


          <!-- Main button -->
          <button (click)="speakAllMessages()" [ngStyle]="{ 'background': getButtonColor() }" #menuBtn>
            <mat-icon style="color: white; height: 22px; width: 35px">campaign</mat-icon>
          </button>
        </div>
        <p-contextMenu [target]="menuBtn" [model]="contextItems" appendTo="body"></p-contextMenu>

      </div>
    </div>

    <div *ngIf="activeTab === 'copilot' && isCopilot" class="copilot" [ngClass]="{ 'full-width': isFullWidth }">

      <app-openai-chat #chatbotContainer [chatWidth]="chatWidth" [isFullWidth]="isFullWidth"
        [draggingWidth]="draggingWidth">
      </app-openai-chat>
    </div>

    <div *ngIf="activeTab === 'help' && isCommunicateCollaborate" class="help">
      <div class="chatbox" #scrollMe [scrollTop]="scrollMe.scrollHeight" *ngIf="chats.length > 0">
        <div *ngFor="let chat of chats" class="chat"
          [ngClass]="{'bot': chat.isBot, 'user': !chat.isBot, 'chat-small' : isFullWidth || draggingWidth, 'w-full' : !isFullWidth && !draggingWidth}">
          <div class="user-photo">
            <img
              [src]="chat.isBot ? 'assets/images/robot-avatar.png' : 'assets/images/O3sigma_logo_blue.png'"><!--<img [src]="chat.isBot ? 'assets/images/O3Help.png' : 'assets/images/o3.png'">-->

          </div>
          <p [ngClass]="{'chat-message-bot':chat.isBot,'chat-message':!chat.isBot}" id="chatMessages">{{
            chat.message }}
            <time class="time-bot">{{ chat.time | date:'shortTime' }}</time>
          </p>
        </div>
      </div>
      <div class="img-center">
        <img *ngIf="isLoader" class="img-size" mat-card-image src="assets/images/loader-o3-help.gif"
          alt="Photo of a loader">
      </div>

      <div class="chat-form img-center">
        <textarea [(ngModel)]="userInput" placeholder="Type your message..."
          (keydown.enter)="sendCommunicationMessage()"></textarea>
        <mat-icon class="icon-send" (click)="sendCommunicationMessage()" matTooltip="Send">
          send
        </mat-icon>
        <mat-icon class="icon-clear" (click)="clearCommunicationMessage()"
          matTooltip="Clear Chat Logs">clear_all</mat-icon>

      </div>

    </div>
  </div>

  <div class="chatbot-tabs">
    <button *ngIf="isNextBestAction" class="tab-button tab-1"
      [ngClass]="{'active':activeTab === 'messages' , 'commonBackgroundColor':activeTab === 'messages'}"
      (click)="switchTab('messages')"><!--[class.active]="activeTab === 'messages'"-->
      <mat-icon> trending_up </mat-icon>
      Next Best Action
    </button>
    <button *ngIf="isCopilot" class="tab-button"
      [ngClass]="{'active':activeTab === 'copilot','commonBackgroundColor':activeTab === 'copilot'}"
      (click)="switchTab('copilot')"><!--[class.active]="activeTab === 'copilot'"-->
      <mat-icon> chat </mat-icon>
      Copilot
    </button>
    <button *ngIf="isCommunicateCollaborate" class="tab-button tab-3"
      [ngClass]="{'active':activeTab === 'help','commonBackgroundColor':activeTab === 'help'}"
      (click)="switchTab('help')"><!--[class.active]="activeTab === 'help'"-->
      <mat-icon> question_answer </mat-icon>
      Communicate & Collaborate
    </button>
  </div>
</div>